import { render, staticRenderFns } from "./EmailsView.vue?vue&type=template&id=19020100&scoped=true"
import script from "./EmailsView.vue?vue&type=script&lang=js"
export * from "./EmailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19020100",
  null
  
)

export default component.exports